/* eslint-disable arrow-body-style */
import React from 'react';
import { TableColumn } from 'tea-component';
import MetricExplanationTips from '@intelligence/v3/components/MetricExplanationTips';
import ColumnsCenter from '@intelligence/components/TableComponents/components/CloumsCenter';
import SortBy, { SortByItemType } from '@intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@intelligence/components/TableComponents/components/TableShowData';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { growthFormat } from '@intelligence/utils/commonUtils';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { getDBIMetric } from '@intelligence/v3/_config/metrics';
import { SortType } from '@intelligence/pages/TopCharts/_config/enums';
import { formatMetricValue } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap//utils';
import { SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';
import { SORTABLE_METRICS_COLUMNS_METADATAS_MAPPING } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/components/Tables/metrics';

import type { ISortableMetricMetadata } from '@intelligence/types/common';
import type { IMobileDetailsOverlapRank } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/types';

const getMetricGrowthDataObj = (metricGrowthRatio?: any) => {
  if (typeof metricGrowthRatio !== 'number' || Number.isNaN(metricGrowthRatio)) {
    return {
      type: '',
      value: '-',
    };
  }

  return growthFormat({
    value: metricGrowthRatio,
    valueType: 'pointValue',
    hasPoint: 'lessThanOne',
    fixedNum: 2,
    maxNumber: 99999,
  });
};

export default function MobileDetailsOverlapMetricColumn(
  params: ISortableMetricMetadata & {
    key: string;
    currentSortKey: string;
    currentSortValue: SortType;
    onSortChage: (sortInfo: SortByItemType) => void;
    entityType?: string;
  },
): TableColumn<IMobileDetailsOverlapRank> {
  const { isCN } = useIntlExtend();

  const {
    key,
    dataSource,
    dataSourceClient,
    metric,
    currentSortKey,
    currentSortValue,
    onSortChage,
    entityType = '',
  } = params || {};
  const sortMetric = metric;

  const dbiMetric = getDBIMetric('mobile', 'sensortower', key);

  const { width } = SORTABLE_METRICS_COLUMNS_METADATAS_MAPPING[key];

  const dataSourceClientTmp = dataSourceClient || dataSource;

  const dataSourceIcon = getDataSourceIcon(dataSourceClientTmp);

  const translatedTitle = isCN ? dbiMetric?.metricName?.cn : dbiMetric?.metricName?.en;

  return {
    key,
    width,
    align: 'right',
    header: () => {
      return (
        <ColumnsCenter align="right" width={width}>
          <SortBy
            titlePointerCursor
            title={translatedTitle}
            svgIcon={dataSourceIcon}
            svgTip={
              <MetricExplanationTips
                // showDataSourceDescription
                entityType={entityType}
                dataSource={dbiMetric?.dataSource}
                metric={dbiMetric?.metricJump}
                data={dbiMetric?.explanation?.en as any}
                dataCN={dbiMetric?.explanation?.cn as any}
              />
            }
            list={[
              {
                key: `${metric}_0`,
                sortMetric,
                orderSource: dataSource,
                text: translatedTitle,
                title: translatedTitle,
                ratioType: 0,
              },
              // {
              //   key: `${metric}_1`,
              //   sortMetric,
              //   orderSource: dataSource,
              //   text: `${translatedTitle}:Change(%)`,
              //   title: `${translatedTitle}(%)`,
              //   ratioType: 1,
              // },
            ]}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            onChange={onSortChage}
          />
        </ColumnsCenter>
      );
    },
    render: (cvm) => {
      const metrics = cvm?.metric_list || [];
      const metric = metrics?.find((item: any) => item?.metric === sortMetric);
      const metricValue = formatMetricValue?.(metric?.metric, metric?.value);
      const metricGrowthRatio = metric?.growth_ratio;
      const metricGrowthDataObj = getMetricGrowthDataObj(metricGrowthRatio);

      return (
        <ColumnsCenter align="center" width={width}>
          <TableShowData
            isDodHide={sortMetric === SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY}
            value={metricValue}
            type={metricGrowthDataObj?.type}
            growth={metricGrowthDataObj?.value}
            maxNumber={'99999+%'}
          />
        </ColumnsCenter>
      );
    },
  };
}
